(function() {
    'use strict';

    angular
        .module('edistradadhluiApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngAnimate',
            'ngCacheBuster',
            'ngFileUpload',
            'ngFileSaver',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ngMaterial',
            'uuid',
            'ngLoadingSpinner'
        ])
        .run(run);

    run.$inject = ['$rootScope', 'stateHandler', 'translationHandler', 'Principal', 'DEBUG_INFO_ENABLED', 'VERSION', '$translate'];

    function run($rootScope, stateHandler, translationHandler, Principal, DEBUG_INFO_ENABLED, VERSION, $translate) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.Principal = Principal;
        $rootScope.DEBUG_INFO_ENABLED = DEBUG_INFO_ENABLED;
        $rootScope.VERSION = VERSION;
        angular.element(window).on("resize", function() {
            $rootScope.$apply();
        });

        $rootScope.$translate = $translate;
        $rootScope.$conditionalTranslate = function(condition, phrase) {
            if (condition)
                return $translate.instant(phrase);
            else return "";
        };

        //        PDFViewerApplication.isViewerEmbedded = true; //This prevents PDF.js to change view title
        //        PDFViewerApplication.postMessageTransfers = false; //This prevents PDF.js to log unnecesarry things
    }
})();
